module.exports = __webpack_public_path__ + "img/mobile-18.33772aa1.png";